import React, { PropTypes } from "react";
import { TextInput } from "../../../../common/form";
import { FormattedMessage } from "react-intl";
import { Field } from "redux-form";

const ClientMajorCost = ({disabled}) => (
  <div className="ClientSubsection">
    <h3>
      <FormattedMessage id="clients.form.majorCost.title" />
    </h3>
    <div className="dollar">
      <Field
        id="majorFixedFee"
        name="majorFixedFee"
        type="absNumber"
        min={0}
        disabled = {disabled}
        component={TextInput}
        label={<FormattedMessage id="clients.form.majorCost.fixedFees" />}
      />
      <Field
        id="majorVariableFee"
        name="majorVariableFee"
        type="absNumber"
        min={0}
        disabled = {disabled}
        component={TextInput}
        label={<FormattedMessage id="clients.form.majorCost.variableFees" />}
      />
    </div>
  </div>
);

ClientMajorCost.propTypes = {
  disabled: PropTypes.bool,
};

export default ClientMajorCost;



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client-form/basic-client-sections/ClientMajorCost.js